import React from "react";
import "./addressSummary.scss";
import addressStore from "../../../store/addressStore";

const AddressSummary = () => {
  const AddressStore = addressStore();

  return (
    <div className="address-summary">
      <div className="main-title">
        <h3>Address Summary</h3>
      </div>
      <div className="address-summary-content">
        <div className="selected-customer-name">
          <div className="customer-name">
            {AddressStore.selectedAddress.fullName}
          </div>
          <div className="address-category">
            ({AddressStore.selectedAddress.addressCategory})
          </div>
        </div>
        <div className="selected-customer-address">
          {AddressStore.selectedAddress.address},{" "}
          {AddressStore.selectedAddress.city} -{" "}
          {AddressStore.selectedAddress.pincode} <br />
          {AddressStore.selectedAddress.state},{" "}
          {AddressStore.selectedAddress.country}
        </div>
        <div className="contact-no">
          {AddressStore.selectedAddress.phoneNumber}
        </div>
      </div>
    </div>
  );
};

export default AddressSummary;
